<div class="header-container flex-grow-1">
  <div class="logo-container">
    <a
      (click)="toggleSidebar()"
      href="#"
      class="sidebar-toggle"
    >
      <nb-icon icon="nb-menu"></nb-icon>
    </a>
  </div>
  <div class="d-flex justify-content-between align-items-center flex-grow-1">
    <div class="logos d-none d-lg-block">
      <a
        href="https://www.regione.toscana.it/"
        target="_blank"
        class="mr-4"
      >
        <img
          src="/assets/images/loghi/logo_regione.png"
          style="height: 47px"
          alt="Regione Toscana"
        />
      </a>
      <a
        href="https://www.regione.toscana.it/sst"
        target="_blank"
        class="mr-4"
      >
        <img
          src="/assets/images/loghi/logo_asl_cut.png"
          style="height: 47px"
          alt="Sistema Sanitario della Toscana - MANAGEMENT E SANITÀ"
        />
      </a>
      <a href="/">
        <img
          src="/assets/images/loghi/logo_hm.png"
          style="height: 47px;"
        >
      </a>
    </div>
    <div class="buttons d-none">
      <ul class="nav navbar-nav navbar-right">
        <li class="nav-item current"><a
            target="blank"
            href="https://celiachia.sanita.toscana.it"
            class="icon cel wow fadeIn"
            style="visibility: visible; animation-name: fadeIn;"
          ><b>&gt;</b> Celiachia</a></li>
        <li class="nav-item"><a
            target="blank"
            href="https://zerocode.sanita.toscana.it"
            class="zero  wow fadeIn"
            style="visibility: visible; animation-name: fadeIn;"
          ><b>&gt;</b> ZERO Code</a></li>
        <li class="nav-item"><a
            target="blank"
            href="https://televisita.sanita.toscana.it"
            class="tele wow fadeIn"
            style="visibility: visible; animation-name: fadeIn;"
          ><b>&gt;</b> Televisita</a></li>
        <li class="nav-item"><a
            target="blank"
            href="https://prenota.sanita.toscana.it"
            class="cup wow fadeIn"
            style="visibility: visible; animation-name: fadeIn;"
          ><b>&gt;</b> CUP online</a></li>
        <li class="nav-item"><a
            target="blank"
            href=" https://fascicolosanitario.regione.toscana.it/"
            class="fascicolo wow fadeIn"
            style="visibility: visible; animation-name: fadeIn;"
          ><b>&gt;</b> Fascicolo sanitario</a></li>
      </ul>
    </div>
  </div>
</div>


<nb-actions
  size="medium"
  class="header-container"
  [class.right]="position === 'normal'"
  [class.left]="position === 'inverse'"
>

  <!--nb-action icon="nb-grid-b" class="toggle-layout" (click)="toggleSettings()"></nb-action-->
  <nb-action>
    <nb-user
      *ngIf="user"
      [nbContextMenu]="currentMenu"
      [name]="user?.nome + ' ' +user?.cognome || user.username"
    >
    </nb-user>
    <!--nb-user [menu]="userMenu" [name]="user?.nome" [picture]="user?.picture"></nb-user-->
  </nb-action>


  <nb-action *ngIf="!user">
    <button
      class="btn btn-block btn-hero-secondary"
      (click)="navigateToLogin($event)"
    >Login</button>

  </nb-action>

  <!-- 
  <nb-action *ngIf="user?.isSuperAdmin">
    <button class="btn btn-block btn-hero-secondary" (click)="navigateToMoodle($event)">Moodle</button>
  </nb-action> -->


  <nb-action>
    <a
      target="_blank"
      href="#/auth/assistenza"
      class="text-success evidence"
      routerLinkActive="active"
    >{{contact_link_text}}</a>
  </nb-action>

</nb-actions>
